import type { CSSProperties } from "react";

export function Hero() {
  return (
    <section
      className="relative w-full overflow-hidden"
      style={{
        background:
          "linear-gradient(135deg, #ffffff 0%, #f2f0f6 45%, #e5e2ec 100%)",
      }}
    >
      <span className="pointer-events-none absolute left-1/2 top-1/2 h-[300px] w-[600px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-white/50 blur-[80px]" />

      <div className="relative z-10 mx-auto flex w-full max-w-[1056px] flex-col items-center gap-5 px-4 py-16 text-center sm:py-20">
        <span className="reveal reveal-1 rounded-full border border-solid border-[#e9e3f5] bg-white/70 px-5 py-2 text-xs font-semibold uppercase tracking-[0.6px] text-brand-purple">
          Get in Touch
        </span>

        <div className="reveal-mask">
          <h1
            className="text-3xl font-bold leading-tight sm:text-4xl lg:text-[44px]"
            style={{ "--reveal-delay": "0.15s" } as CSSProperties}
          >
            <span className="text-[#1e293b]">We're Here to </span>
            <span
              className="bg-clip-text text-transparent"
              style={{
                backgroundImage: "linear-gradient(90deg, #1e293b 0%, #3e025c 100%)",
              }}
            >
              Help You.
            </span>
          </h1>
        </div>

        <p className="reveal reveal-3 max-w-[672px] text-base leading-7 text-[#475569] sm:text-lg">
          Complete the form and we'll be in touch shortly. Have a question
          about your loan or need help with your application? Reach out to
          our support team and we'll help you find the right way forward.
        </p>
      </div>
    </section>
  );
}
